import { z } from 'zod';
/**
 * Professions of licensed professionals ("Berufsträger"; NEONEWTON 4: StB, RA, WP).
 * The profession belongs to the person, not to the firm.
 */
export const Profession = z.enum(['StB', 'StBv', 'RA', 'WP', 'vBP']).meta({ id: 'Profession' });
export const professionLabel = {
    StB: 'Steuerberater:in',
    StBv: 'Steuerbevollmächtigte:r',
    RA: 'Rechtsanwält:in',
    WP: 'Wirtschaftsprüfer:in',
    vBP: 'vereidigte:r Buchprüfer:in',
};
/** Employee categories (NEONEWTON 4). */
export const EmployeeCategory = z.enum(['fachkraft', 'orgakraft', 'hilfskraft']);
/** Location types (NEONEWTON 4). */
export const LocationType = z
    .enum(['niederlassung', 'beratungsstelle'])
    .meta({ id: 'LocationType' });
/**
 * Legal forms. There is deliberately no `unbekannt` (unknown) value: an unknown legal form
 * is an assertion with `availability = unknown` (check case "Unknown legal form", paper §14.2).
 */
export const LegalForm = z
    .enum([
    'natuerliche_person',
    'einzelunternehmen',
    'gbr',
    'ohg',
    'kg',
    'gmbh_co_kg',
    'partg',
    'partg_mbb',
    'gmbh',
    'ug',
    'ag',
    'eg',
    'ev',
    'stiftung',
    'sonstige',
])
    .meta({ id: 'LegalForm' });
export const legalFormLabel = {
    natuerliche_person: 'Natürliche Person',
    einzelunternehmen: 'Einzelunternehmen',
    gbr: 'Gesellschaft bürgerlichen Rechts (GbR)',
    ohg: 'Offene Handelsgesellschaft (OHG)',
    kg: 'Kommanditgesellschaft (KG)',
    gmbh_co_kg: 'GmbH & Co. KG',
    partg: 'Partnerschaftsgesellschaft (PartG)',
    partg_mbb: 'PartG mit beschränkter Berufshaftung (PartG mbB)',
    gmbh: 'GmbH',
    ug: 'UG (haftungsbeschränkt)',
    ag: 'Aktiengesellschaft (AG)',
    eg: 'Eingetragene Genossenschaft (eG)',
    ev: 'Eingetragener Verein (e. V.)',
    stiftung: 'Stiftung',
    sonstige: 'Sonstige Rechtsform',
};
//# sourceMappingURL=firm.js.map